import { Component, Input } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SnackbarService } from '../services/snackbar.service';
import { environment } from 'projects/foreign-admits/src/environments/environment';
import { ApiHelperService } from 'projects/apna-lib/src/lib/services/api-helper.service';

@Component({
  selector: 'app-connect-counsellor',
  templateUrl: './connect-counsellor.component.html',
  styleUrls: ['./connect-counsellor.component.scss'],
})

export class ConnectCounsellorComponent {
  @Input() puid: string = '';
  isModalOpen: boolean = false;
  showSuccessModal: boolean = false;
  selectedDate: string = '';
  selectedTime: string = '';
  selectedTimeSlot: string = '';

  // Predefined time slots
  timeSlots: string[] = ['8:00 - 11:00', '11:00 - 14:00', '14:00 - 17:00', '17:00 - 20:00'];
  private baseUrl: string = environment.apiBaseUrl;
  constructor(private http: HttpClient,
    private snackbarService: SnackbarService,
    private apiHelperService: ApiHelperService
  ) {}

  // Open Modal
  openModal() {
    this.isModalOpen = true;
  }


  closeModal() {
    this.isModalOpen = false;
    this.showSuccessModal = false;
    this.selectedDate = '';
    this.selectedTime = '';
  }


  bookCounsellorCall() {
    if (!this.selectedDate || !this.selectedTimeSlot) {
      alert('Please select both a date and time slot.');
      return;
    }
    const uid = localStorage.getItem('uid');
    if (!uid) {
      alert('User ID is missing. Please log in again.');
      return;
    }

    const token = localStorage.getItem('token');
    if (!token) {
      console.error('No access token found');
      return;
    }

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });

    const requestData = {
      puid: this.puid, 
      uid: uid,
      date: this.selectedDate,
      timeSlot: this.selectedTimeSlot,
    };
    console.log(requestData, 46)
    // Send data to the backend using API helper
    this.apiHelperService.postDataWithShortlistingUrl('partner-details/connect-counsellor', requestData).then(
      (response) => {
        console.log('Call booked successfully:', response);
        this.isModalOpen = false;  
        this.showSuccessModal = true; 
        setTimeout(() => {
          this.closeSuccessModal();  // Automatically close success modal after 3 seconds
        }, 4000);
      }
    ).catch(
      (error) => {
        console.error('Error booking call:', error);
        if (error.status === 429) {
          this.snackbarService.show('You cannot book more than 2 calls within 7 days. Please try again later.', 'error')
          this.isModalOpen = false;
        } else {
          this.snackbarService.show('Failed to book call. Please try again.', 'error');
        }
       
      }
    );
  }

  closeSuccessModal() {
    this.showSuccessModal = false;
  }

}
